export enum LoginRouteNames {
  LOGIN = 'Login',
  PASSWORD_RESET = 'PasswordReset',
}
